import { Box, CircularProgress } from '@locus-taxy/encore-mui';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';
import { useMemo } from 'react';

interface LoadingSpinnerProps {
  size?: number;
  color?: 'primary' | 'secondary' | 'inherit';
  message?: string;
  showRandomMessage?: boolean;
}

export default function LoadingSpinner({
  size = 40,
  color = 'primary',
  message,
  showRandomMessage = true,
}: Readonly<LoadingSpinnerProps>) {
  const { t } = useTranslation('fallback');

  // Generate a random loading message
  const randomMessage = useMemo(() => {
    if (!showRandomMessage) {
      return null;
    }

    const messageKeys = [
      'common.loadingMessages.message1',
      'common.loadingMessages.message2',
      'common.loadingMessages.message3',
      'common.loadingMessages.message4',
      'common.loadingMessages.message5',
      'common.loadingMessages.message6',
      'common.loadingMessages.message7',
      'common.loadingMessages.message8',
    ];

    const randomIndex = Math.floor(Math.random() * messageKeys.length);
    return t(messageKeys[randomIndex]);
  }, [t, showRandomMessage]);

  const displayMessage = message || randomMessage;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flexGrow: 1,
        minHeight: 0,
        gap: 2,
      }}
    >
      <CircularProgress size={size} color={color} />
      {displayMessage && (
        <Box
          sx={{
            color: 'text.secondary',
            fontSize: '12px',
            textAlign: 'center',
            maxWidth: 300,
          }}
        >
          {displayMessage}
        </Box>
      )}
    </Box>
  );
}
